(function () {
  // 产品页右侧弹出菜单后，自动跳转到指定的tag内容
  async function handleProductTabLable() {
    await MB_waitElementReady(".mibao_product_tag_lables a");
    $(".mibao_product_tag_lables a").click(function () {
      const lable = $(this).data("mibao-product-tag-lable");
      const index = $("#mibao-product-detail-drawer ul.t4s-tabs-ul li a")
        .map((i, o) => $(o).text())
        .toArray()
        .findIndex((o) => o == lable);
      $("#mibao-product-detail-drawer ul.t4s-tabs-ul").flickityt4s(
        "selectCell",
        index
      );
      $($("#mibao-product-detail-drawer ul.t4s-tabs-ul li a")[index]).click();
    });
  }
  async function moveSku() {
    const el =
      ".t4s-section-main-product>.t4s-container [id*=t4s_tab][id*=features]";
    await MB_waitElementReady(el);
    $(".t4s-sku-wrapper").appendTo(el);
  }
  // async function onColorSwatchChange() {
  //   const el = ".t4s-swatch__item.mibao_many_line_color";
  //   await MB_waitElementReady(el);
  //   $(el).click(function () {
  //     const color = $(this).text();
  //     const title = $(this).prevAll("h4").first();
  //     $(".mibao-swatch__current").text("");
  //     title.find(".mibao-swatch__current").text(color);
  //     // console.log(this, $(this).prevAll('h4'), title)
  //   });
  // }

  // 调整judgeme的位置
  async function handleTemplateJudgeMeDom() {
    const target_posi_el = '#judgeme_product_reviews .jdgm-row-stars .jdgm-rev-widg__summary'
    const average_el = "#judgeme_product_reviews .jdgm-row-stars .jdgm-rev-widg__summary-inner .jdgm-rev-widg__summary-average";
    console.log('handleJudgeMeDom', $(average_el))
    // const sum_el = ".jdgm-row-stars .jdgm-rev-widg__summary .jdgm-rev-widg__summary-inner"
    await MB_waitElementReady(average_el);
    $(average_el).parents(target_posi_el).prepend($(average_el))
  }

  async function handleTabJudgeMeDom() {
    const target_posi_el = '#judgeme_product_reviews_snippets .jdgm-row-stars .jdgm-rev-widg__summary'
    const average_el = "#judgeme_product_reviews_snippets .jdgm-row-stars .jdgm-rev-widg__summary-inner .jdgm-rev-widg__summary-average";
    // const sum_el = ".jdgm-row-stars .jdgm-rev-widg__summary .jdgm-rev-widg__summary-inner"
    await MB_waitElementReady(average_el);
    $(average_el).parents(target_posi_el).prepend($(average_el))
  }

  function init() {
    MB_jsDeferHandle(handleProductTabLable, ["jQuery"]);
    // MB_jsDeferHandle(handleProductTabIco, ["jQuery"]);
    MB_jsDeferHandle(moveSku, ["jQuery"]);
    // MB_jsDeferHandle(onColorSwatchChange, ["jQuery"]);
    MB_jsDeferHandle(handleTemplateJudgeMeDom, ["jQuery"]);
    MB_jsDeferHandle(handleTabJudgeMeDom, ["jQuery"]);
  }

  MB_jsDeferHandle(init, ["jQuery"]);
})();

(function () {
  // 非商详情页，不执行
  if (!meta.product) {
    return
  }
  document.addEventListener("DOMContentLoaded", function () {
    try {
      // 创建一个函数来设置观察者，当目标元素存在时执行
      const setupCartObserver = (targetElement) => {
        // 底部吸底button
        const fixedButton = document.getElementById('add_cart_wrapper')

        // 创建观察点元素
        const observerElement = document.querySelector(".hq_addCart_observer");
        targetElement.classList.add("hq_addCart_initialize");

        // 直接在目标元素后面插入观察点和占位符
        targetElement.insertAdjacentElement("afterend", observerElement);

        // 添加一个标志位，用于忽略初始化时的第一次触发
        let isFirstIntersection = true;

        // 创建 IntersectionObserver 实例
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // 获取观察点相对于视窗的位置信息
              const boundingRect = entry.boundingClientRect;

              // 如果是第一次触发，则忽略并重置标志位
              if (isFirstIntersection) {
                isFirstIntersection = false;
                // 确保初始状态下不添加固定类
                fixedButton.classList.remove("show")
                return;
              }

              if (!entry.isIntersecting && boundingRect.top < 60) {
                // 当观察点移出视窗且位于视窗上方时，添加固定类
                fixedButton.classList.add("show")
              } else {
                // 其他情况下移除固定类
                fixedButton.classList.remove("show");
              }
            });
          },
          {
            root: null,
            rootMargin: "-60px 0px 0px 0px", // 视窗顶部收缩60px的检测区域
            threshold: 0,
          }
        );

        // 开始观察
        observer.observe(observerElement);

        // 确保初始状态正确
        setTimeout(() => {
          // 页面加载完成后，根据实际滚动位置决定是否应该固定
          const rect = observerElement.getBoundingClientRect();
          if (rect.top < 60 && !isElementInViewport(observerElement)) {
            fixedButton.classList.add("show");
          }
        }, 100);

        console.log(">>> 购物车吸底功能已启用");
      };

      // 辅助函数：检查元素是否在视窗内
      function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
        );
      }


      // 先尝试直接获取目标元素
      let targetElements = document.querySelectorAll('.add-cart-btn_wrapper');


      targetElements && setupCartObserver(targetElements[0]);
    } catch (error) {
      console.error(">>> AddToCart fixed error:", error);
    }
  });
})();

